export const transactionExpress = /^[0-9]{4}$/;
export const transactionExpressForInput = "[0-9]{4}";

export const passwordExpress = /^[A-Za-z\d]{6,}$/;
export const passwordExpressForInput = "[A-Za-z\\d]{6,}";

export const phoneExpress = /^\d{10}$/;
export const phoneExpressForInput = "\\d{10}";
